import { useTranslate } from "ra-core";

import type { QuoteStatus } from "../types";

export const useQuoteStatusLabel = () => {
  const translate = useTranslate();
  return (status: QuoteStatus) =>
    translate(`crm.quotes.status.${status}`, {
      _: {
        draft: "Utkast",
        sent: "Sendt",
        accepted: "Akseptert",
        declined: "Avslått",
      }[status],
    });
};
